/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const ErrorInfo = require('./ErrorInfo');
const ERROR_CODES = require('./errcodes');

const allErrors = {};
let errorValues = [];

class FunctionErrors {
	static of(...errors) {
		const funcErrors = new FunctionErrors();
		return funcErrors.add(Object.assign({}, ...errors));
	}

	get code() {
		return allErrors;
	}

	add(errors = {}) {
		Object.assign(allErrors, errors);
		errorValues = Object.values(allErrors);
		return this;
	}

	isError(value) {
		return value != null && (value.isErrorInfo || errorValues.includes(value)) ? value : undefined;
	}

	isErrorCode(value, code) {
		if (value != null) return value.isErrorInfo ? value.code === code : value === code;
		return false;
	}
	// getErrorCode(value) {
	// 	if (value == null) return undefined;
	// 	if (value.isErrorInfo) return value.code;
	// 	return errorValues.includes(value) ? value : undefined;
	// }

	containsError(values) {
		return values.some((value) => this.isError(value));
	}

	ifNot(condition, error) {
		return !condition ? error : undefined;
	}

	ifTrue(condition, error) {
		return condition ? error : undefined;
	}

	localizeError(error, locale) {
		return ErrorInfo.localize(error, locale);
	}
}

module.exports = FunctionErrors.of(ERROR_CODES); // ERRORS, EXCEL_ERRORS);
